import type { AttachedFile } from './files';

export enum WebsocketEvents {
  AppMessage = '/app/message',
  UserEvents = 'queue/message-events',
  ErrorEvents = 'queue/error-events',
}

export enum WebsocketMessageType {
  /** Системные автоотбивки, запрос csat */
  OutSystem = 'OUT_SYSTEM',
  /** Ответ агента */
  OutRequest = 'OUT_REQUEST',
  /** Ответ агента и закрытие тикета */
  OutReply = 'OUT_REPLY',
  /** Любая реплика пользователя */
  In = 'IN',
}

export enum WebsocketErrorType {
  FileUploadRateLimiter = 'FILE_UPLOAD_RATE_LIMITER_ERROR',
  MessageRateLimiter = 'MESSAGE_RATE_LIMITER_ERROR',
}

export enum WebsocketMessageContentType {
  Html = 'HTML',
  Text = 'TEXT',
  JsonCsatRequest = 'JSON_CSAT_REQUEST',
  JsonCsatResponse = 'JSON_CSAT_RESPONSE',
  JsonChatBotRequest = 'JSON_CHATBOT_REQUEST',
  JsonChatBotResponse = 'JSON_CHATBOT_RESPONSE',
}

export interface WebSocketMessageCSATButton {
  text: string;
  value: string;
  isRating?: boolean;
}

interface WebSocketMessageJson {
  title: string;
  titleHtml?: string | null;
  buttons: [WebSocketMessageCSATButton[]];
}

/** Поля, общие для сообщений из WS и доменных сообщений */
export interface MessageCore {
  id: number;
  authorName: string;
  createDate: string;
  message: string;
  messageHtml?: string | null;
  messageType: WebsocketMessageType;
  messageContentType: WebsocketMessageContentType;
}

export interface WebSocketMessage extends MessageCore {
  messageJson: WebSocketMessageJson | null;
  attachments: AttachedFile[];
}
